import { state, useReactiveMap } from '@frameio/graphql-client';
import type { TransferBatchReactiveMapState } from '@frameio/graphql-client/client-schema/transfers/state/transferJobs';

/**
 * Hook used to get transfer jobs data stored a reactive map.
 * This data is also currently stored in local storage.
 * This data is not currently used in the Apollo cache.
 * @returns a reactive map of upload jobs containing all of their tasks, and the last updated time.
 */
export const useGetTransferJobs = () => {
  const transferJobs: TransferBatchReactiveMapState = useReactiveMap(
    state.transfers.transferBatches,
    'default'
  );
  return transferJobs;
};
